import React, {useRef, useState} from "react";
import useOnClickOutside from "use-onclickoutside";
import {useDispatch, useSelector} from "react-redux";

import ResendSmsLink from "../AdmissionsList/Item/MoreDrop/ResendSmsLink";
import CloneToDemoLink from "../AdmissionsList/Item/MoreDrop/CloneToDemoLink";
import CloneToTestLink from "../AdmissionsList/Item/MoreDrop/CloneToTestLink";
import ArchiveAdmissionDocumentsLink from "../AdmissionsList/Item/MoreDrop/ArchiveAdmissionDocumentsLink";
import CopyAdmissionData from "../AdmissionsList/Item/MoreDrop/CopyAdmissionData";
import ManagerCustomUI_MoreDrop from "../AdmissionsList/Item/MoreDrop/ManagerCustomUI_MoreDrop";
import ToggleSmsOptOutLink from "../AdmissionsList/Item/MoreDrop/ToggleSmsOptOutLink";
import Imp406Link from "../AdmissionsList/Item/MoreDrop/Imp406Link";
import {useCustomLogic} from "../../utils/customLogic";
import * as actionTypes from "../../store/actions/actionTypes";
import {MODAL_ADMISSION_FYDO_PREVIEW_XML_SHOW} from "../../store/actions/actionTypes";
import {fydoPreviewXml, auroraPreviewRegXml} from "../../store/actions/modal";
import LifehouseAdmissionReminder from "../AdmissionsList/Item/MoreDrop/LifehouseAdmissionReminder";
import ToggleExternalCompletionLinks from "../AdmissionsList/Item/MoreDrop/ToggleExternalCompletionLinks";
import {useToasts} from "react-toast-notifications";

const Admission_MoreDrop = ({admission}) => {
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    const {isCustomLogicLifehouse, isCustomLogicFortius, isCustomLogicAurora, isCustomLogicBPH, isCustomLogicStLuke} = useCustomLogic();

    const popupRef = useRef(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const hidePopup = () => setPopupOpen(false);
    useOnClickOutside(popupRef, hidePopup);

    const togglePopup = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPopupOpen(!popupOpen);
    }

    const renderDevUI = () => (
                <>
                    <div className="dropdown-divider" />
                    <CopyAdmissionData admission={admission} />
                    <Imp406Link admission={admission} onHide={hidePopup}/>
                    <div className="dropdown-divider" />
                    <CloneToDemoLink admission={admission}/>
                    <CloneToTestLink admission={admission}/>
                    <ToggleExternalCompletionLinks admission={admission}/>
                </>
            );

    return (
        <div className="more-options-drop btn" ref={popupRef}>
            <button type="button" className="dropdown-toggle dropdown-toggle-split" onClick={togglePopup}
                    id={`adm_dropdownMenuReference_${admission.id}`} data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" data-reference="parent" >
                <span><i className="icon ico-more" /></span>
            </button>
            {popupOpen && <div className="dropdown-menu dropdown-menu-right show"
                 aria-labelledby={`adm_dropdownMenuReference_${admission.id}`}>
                <ManagerCustomUI_MoreDrop admission={admission} onHide={hidePopup}/>
                <ResendSmsLink admission={admission}/>
                <ArchiveAdmissionDocumentsLink admission={admission} onHide={hidePopup}/>
                {isCustomLogicLifehouse() && <ToggleSmsOptOutLink admission={admission}/> }
                {(isCustomLogicFortius() || isCustomLogicBPH()) && <_FydoViewXml admission={admission} onHide={hidePopup}/> }
                {(isCustomLogicAurora() || isCustomLogicStLuke()) && <_AuroraViewXml admission={admission} onHide={hidePopup}/> }
                {state_showDevUI && renderDevUI()}
                {isCustomLogicLifehouse() && <LifehouseAdmissionReminder admission={admission}/> }
            </div>}
        </div>
    );
}

const _FydoViewXml = ({admission, onHide}) => {
    const dispatch = useDispatch();

    const uploadPdf = () => {
        onHide();
        dispatch(fydoPreviewXml(admission));
    }

    return (
        <a className="dropdown-item pointer" onClick={uploadPdf}>[FYDO] - preview integration XML</a>
    );
}

const _AuroraViewXml = ({admission, onHide}) => {
    const dispatch = useDispatch();
    const {addToast} = useToasts();

    const previewXml = () => {
        onHide();
        dispatch(auroraPreviewRegXml(admission, addToast));
    }

    return (
        <a className="dropdown-item pointer" onClick={previewXml}>[RegXML] - preview admission Reg XML</a>
    );
}


export default Admission_MoreDrop;